module.exports = __webpack_public_path__ + "static/4-045194b29ca51711c4471011467ddfb4.jpg";